export const handleNavigation = (navigate, path) => {
  navigate(path);
};

export const handleMenuClick = (navigate, path) => {
  navigate(path); // Apenas navega
};

export const handleAnchorNavigation = (navigate, path, anchor) => {
  navigate(path);
  setTimeout(() => {
    const element = document.getElementById(anchor);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, 100);
};